import { onApiError } from "../error"
import { del, get, put } from "./client"

/**
 * @param {string} imei 
 * @returns {Promise<Smartplug2>}
 */
export async function delSp2Consumption(imei) {
    const res = await del(`/smartplug2s/${imei}/consumption`)
    if (!res.ok) throw await onApiError(res)
    const sp2 = await res.json()
    return sp2
}

/**
 * @param {string} imei 
 * @returns {Promise<Smartplug2>}
 */
export async function getSp2(imei) {
    const res = await get(`/smartplug2s/${imei}`)
    if (!res.ok) throw await onApiError(res)
    const sp2 = await res.json()
    return sp2
}

/**
 * @param {Smartplug2} sp2 
 */
export async function putSp2(sp2) {
    const res = await put(`/smartplug2s/${sp2.Imei}`, {
        body: JSON.stringify(sp2)
    })

    if (!res.ok) throw await onApiError(res)

    sp2 = await res.json()
    return sp2
}
